import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../common/components/loading/SkeletonElement/SkeletonElement';

const DesktopLeftNavSkeleton = () => {
  return (
    <nav
      className={css({
        display: 'flex',
        flexDirection: 'column',
        fontSize: '12px',
        alignItems: 'center',
        position: 'fixed',
        top: '72px',
        insetInline: 0,
        bgColor: 'neutrals.card_fill_primary',
        height: 'calc(100vh - 72px)',
        width: '73px',
        py: '26px',
        px: 'extra_small_2',
        gap: 'small',
        borderInlineEnd: '1px solid',
        borderInlineEndColor: 'neutrals.divider',
      })}
      data-testid="desktop-left-nav-skeleton"
    >
      <SkeletonElement />
      <SkeletonElement />
    </nav>
  );
};

export { DesktopLeftNavSkeleton };
